itsoftApp.createModule("formsValidation", ["pageLoad"], function() {
    var module = this;
    var captchaId = document.querySelector("#captcha");

    var startSetup = function () {
        var RECAPTCHA_KEY;

        if (captchaId) {
            window.onRecaptchaLoadCallback = function () {
                window.clientId = grecaptcha.render("captcha", {
                    "sitekey": RECAPTCHA_KEY,
                    "badge": "inline",
                    "size": "invisible"
                });
            }

            itsoftApp.loadScript("https://www.google.com/recaptcha/api.js?render=explicit&onload=onRecaptchaLoadCallback", function () {
                init();
            });
        } else {
            itsoftApp.loadScript("https://www.google.com/recaptcha/api.js?render=" + RECAPTCHA_KEY, function () {
                init();
            });
        }
    }

    var init = function() {
        var form = document.querySelector(".js-form-validate");
        var popupId = form.getAttribute("data-result-id");
        var allInputs = form.querySelectorAll(".form__input");
        var allFormFlags = form.querySelectorAll(".form__flag");
        var formCaptcha = form.getAttribute("data-captcha");
        var inputEventFlag = false;
        var submitFlag = false;
        var inputsTel = document.querySelectorAll('.form__input-wrapper--tel .form__input');
        var formInputsFileWrapper = document.querySelectorAll(".form__input-wrapper--file");

        if (formCaptcha) {
            var inputToken = form.querySelector(".form__token");
            var inputAction = form.querySelector(".form__action");
        }
        var popupResult;

        if (popupId) {
            popupResult = document.querySelector(popupId);
        } else {
            popupResult = document.querySelector("#popup-result");
        }

        var submitButton = form.querySelector("button[type='submit']");

        var onFormSubmit = function (evt) {
            evt.preventDefault();

            if (!submitFlag) {
                submitFlag = true;

                if (!formCaptcha) {
                    sendRequest(new FormData(form), onSuccessLoad, onErrorLoad);
                } else {
                    grecaptcha.ready(function () {
                        grecaptcha.execute(clientId, {action: "question_form"}).then(function (token) {
                            inputToken.setAttribute("value", token);
                            inputAction.setAttribute("value", "question_form");
                            sendRequest(new FormData(form), onSuccessLoad, onErrorLoad);
                        });
                    });
                }
            }
        }

        var validateForm = function () {
            var checkInput = function (input) {
                input.setCustomValidity("");

                input.classList.add("js-error")
            }

            var onFieldInput = function (evt) {
                if (evt.target.checkValidity()) {
                    if (evt.target.classList.contains("js-error")) {
                        evt.target.classList.remove("js-error")
                    }
                };
            }

            var onInputInvalid = function (evt) {
                checkInput(evt.target);

                if (!inputEventFlag) {
                    inputEventFlag = true;

                    Array.prototype.forEach.call(allInputs, function (input) {
                        input.addEventListener("input", onFieldInput);
                    });

                    Array.prototype.forEach.call(allFormFlags, function (flag) {
                        flag.addEventListener("change", onFieldInput);
                    });
                }
            }

            Array.prototype.forEach.call(allInputs, function (input) {
                input.addEventListener("invalid", onInputInvalid);
            });

            Array.prototype.forEach.call(allFormFlags, function (flag) {
                flag.addEventListener("invalid", onInputInvalid);
            });
        }

        var onErrorLoad = function (data) {
            popupResult.classList.add("js-error");
            popupResult.dispatchEvent(openEvent);
            submitFlag = false;
        }

        var resetForm = function () {
            var inputsFilled = form.querySelectorAll(".form__input--filled");
            
            form.reset();

            Array.prototype.forEach.call(inputsFilled, function (input) {
                input.classList.remove("form__input--filled");
            });
        }

        var onSuccessLoad = function (data) {
            var parentPopup = form.closest(".popup");
            if (parentPopup) {
                parentPopup.dispatchEvent(closeEvent);
            }
            resetForm();
            popupResult.classList.add("js-success");
            popupResult.dispatchEvent(openEvent);
            submitFlag = false;
        }

        var sendRequest = function (data, onSuccess, onError) {
            var xhr = new XMLHttpRequest();
            var URL = form.action;

            xhr.addEventListener("load", function () {
                if (popupResult.classList.contains("js-success")) {
                    popupResult.classList.remove("js-success");
                }

                if (popupResult.classList.contains("js-error")) {
                    popupResult.classList.remove("js-error");
                } 

                if (xhr.status === 200 && onSuccess) {
                    onSuccess(xhr.response);
                } else {
                    onError(xhr.response);
                }
            });

            xhr.open("POST", URL);
            xhr.send(data);
        }

        var checkInputsTel = function (inputsTel) {
            for (var i = 0; i < inputsTel.length; i++) {
                Inputmask('+7 (999) 999-99-99', {showMaskOnHover: false }).mask(inputsTel[i]);
            }
        }

        var onInputFileChange = function (inputWrapper) {
            var input = inputWrapper.querySelector(".form__file-input");
            var formFilename = inputWrapper.querySelector(".form__file-name");
            var formFileText = formFilename.querySelector(".form__file-text");
            input.addEventListener("change", function (evt) {
                var files = input.files;

                if (inputWrapper.classList.contains("is-error")) {
                    var errorMessage = inputWrapper.querySelector(".form__error-msg");
                    if (errorMessage) {
                        if (files.length > 0 && errorMessage.classList.contains("filled")) {
                            errorMessage.parentNode.removeChild(errorMessage);
                        }
                    }
                }
                if (files.length > 0) {
                    formFileText.textContent = files[0].name;
                } else {
                    formFileText.textContent = "";
                }
            })
        }

        var addInputFileListener = function (inputsWrapper) {
            for (var i = 0; i < inputsWrapper.length; i++) {
                onInputFileChange(inputsWrapper[i]);
            }
        }

        if (inputsTel.lngth > 0) {
            itsoftApp.loadScript("/assets/scripts/inputmask/inputmask.min.js", function () {
                checkInputsTel(inputsTel);
            });
        }

        if (formInputsFileWrapper) {
            addInputFileListener(formInputsFileWrapper);
        }

        validateForm();
        form.addEventListener("submit", onFormSubmit);
    };

    module.callback = startSetup;
});